import { render } from "./PaySalaries.vue?vue&type=template&id=13c30df7&scoped=true"
import script from "./PaySalaries.vue?vue&type=script&lang=js"
export * from "./PaySalaries.vue?vue&type=script&lang=js"

import "./PaySalaries.vue?vue&type=style&index=0&id=13c30df7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c30df7"]])

export default __exports__